module.exports = __webpack_public_path__ + "img/builder-18.bef45d7e.webp";